import { render } from "./cookie-bar.vue?vue&type=template&id=1a70989c"
import script from "./cookie-bar.vue?vue&type=script&lang=js"
export * from "./cookie-bar.vue?vue&type=script&lang=js"

import "./cookie-bar.vue?vue&type=style&index=0&id=1a70989c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__